import React, { FC, useEffect } from "react";

import { StoragesValuesView } from "../../../../redux/slices/grainTracker/grainTrackerTypes";

import { Checkbox, Tooltip } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { v4 as uuidv4 } from "uuid";
import { showCorrectSVG } from "../../locationDetailsGrainTracker/binDesignCard";
import ceroPercent from "../../../../assets/images/silosGrainWise/cero.svg";
import { useTranslation } from "react-i18next";
import { FetchingSharingStatusData } from "../../../../redux/slices/shareSite/shareSiteTypes";

type ShareSiteBinCardsParams = {
  storages: StoragesValuesView[];
  setSelectedStoragesIds: (values: string[]) => void;
  selectedStoragesIds: string[];
  selectedSpecie: number;
  selectedType: string;
  infiniteId: number;
  setToKeep: (values: string[]) => void;
  setToDelete: (values: string[]) => void;
  toDelete: string[];
  toKeep: string[];
  sharingStatus: FetchingSharingStatusData;
};

const ShareSiteBinCards: FC<ShareSiteBinCardsParams> = ({
  storages,
  setSelectedStoragesIds,
  selectedStoragesIds,
  selectedSpecie,
  selectedType,
  infiniteId,
  setToDelete,
  setToKeep,
  toDelete,
  toKeep,
  sharingStatus,
}) => {
  const [t] = useTranslation("global");
  const blah = () => void 0;
  const sharingStatusObject = sharingStatus.data.map((val) => ({
    id: val.id,
    storageInstanceId: val.storageInstanceId,
    sharingIsForced: val.sharingIsForced,
  }));

  const storagesWithStatusInformation = storages.reduce((arr: any, e: any) => {
    arr.push(
      Object.assign({}, e, {
        sharingStatus: sharingStatusObject.find(
          (a) => a.storageInstanceId === e.id
        ),
      })
    );
    return arr;
  }, []) as StoragesValuesView[];

  const statusChange = (
    id: string,
    sharingStatus:
      | {
          id: string;
          storageInstanceId: string;
          sharingIsForced: boolean;
        }
      | undefined
  ) => {
    if (selectedStoragesIds.includes(id)) {
      if (sharingStatus) {
        setToDelete([...toDelete, id]);
      }

      setSelectedStoragesIds(selectedStoragesIds.filter((item) => item !== id));
    } else {
      if (sharingStatus) {
        setToDelete(toDelete.filter((item: string) => item !== id));
      }
      setSelectedStoragesIds([...selectedStoragesIds, id]);
    }
  };

  const filtering = storagesWithStatusInformation.filter((val) => {
    if (
      selectedSpecie === infiniteId &&
      selectedType === infiniteId.toString()
    ) {
      return {};
    } else if (
      selectedSpecie === val.cerealTypeId &&
      selectedType === infiniteId.toString()
    ) {
      return val;
    } else if (
      selectedSpecie === val.cerealTypeId &&
      selectedType === val.storageTemplateId
    ) {
      return val;
    } else if (
      selectedSpecie === infiniteId &&
      selectedType === val.storageTemplateId
    ) {
      return val;
    }
  });

  useEffect(() => {
    if (sharingStatusObject) {
      setSelectedStoragesIds(
        sharingStatusObject.map((s) => s.storageInstanceId)
      );

      setToDelete([]);
    }
  }, []);

  return filtering.map((values) => {
    const getPercentage =
      (100 * values?.usedCapacity?.value) / values?.totalCapacity?.value;

    if (storages.length >= 1) {
      return (
        <div
          key={values.id}
          onClick={() => {
            !values.sharingStatus?.sharingIsForced
              ? statusChange(values.id, values.sharingStatus)
              : blah();
          }}
          role="none"
          className={
            !selectedStoragesIds.includes(values.id)
              ? "bin-card-container-share-site  mt-2 mr-2"
              : "bin-card-container-share-site-selected  mt-2 mr-2"
          }
        >
          <div className="bin-card-name-loc-share-site">
            <div>{values.name}</div>
            <div>
              <Checkbox
                disabled={values.sharingStatus?.sharingIsForced}
                checked={selectedStoragesIds.includes(values.id)}
              />
            </div>
          </div>

          <div className="share-site-criteria-values">
            <div className="bin-information-share-site">
              <div className="bin-information-card-specie-share-site">
                <div className="left-information-card-specie-share-site ">
                  {t("Common_options.specie")}
                </div>
                <div
                  className="chip-cereal-card-loc-view-share-site"
                  style={{
                    background: `${values.cerealType?.iconBackgroundHexColor}`,
                  }}
                >
                  {values.cerealType?.textId?.text}
                </div>
              </div>

              <div className="bin-information-card-specie-share-site">
                <div className="left-information-card-specie-share-site ">
                  {t("Gran_tracker_bins.available-capacity")}
                </div>
                <div className="chip-cereal-card-loc-view-share-site">
                  <div>
                    {(values?.totalCapacity?.value ?? 0) -
                      (values?.usedCapacity?.value ?? 0)}{" "}
                    {values.totalCapacity?.unit?.unitSymbolTextId.text}
                  </div>
                  <div>/</div>
                  <div className="tons-card-available-loc-details-share-site">
                    {values?.totalCapacity?.value}{" "}
                    {values.totalCapacity?.unit?.unitSymbolTextId.text}
                  </div>
                  <Tooltip
                    title={
                      values?.totalCapacity?.unit?.unitDescriptionTextId?.text
                    }
                    sx={{ marginLeft: "10px" }}
                  >
                    <InfoOutlinedIcon sx={{ fontSize: "16px" }} />
                  </Tooltip>
                </div>
              </div>
              <div className="characteristics-container-card">
                {values.currentCharacteristics
                  .map((values) => (
                    <div
                      className="characteristics-container-card-info-share-site"
                      key={uuidv4()}
                    >
                      <div>{values.name}</div>
                      <div> {values.value} </div>
                    </div>
                  ))
                  .slice(1)}
              </div>
            </div>
            <div className="bin-svg">
              <img
                className="percentages-img-svg-location-empty"
                src={ceroPercent}
                alt={"silo"}
              />
              {getPercentage >= 25 ? (
                <img
                  className={
                    getPercentage >= 100
                      ? "percentages-img-svg-location-hundred"
                      : "percentages-img-svg-location"
                  }
                  src={showCorrectSVG(getPercentage)}
                  style={{
                    backgroundColor: `${values.cerealType?.iconBackgroundHexColor}`,
                  }}
                  alt={"silo"}
                />
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      );
    } else {
      return "";
    }
  });
};

export default ShareSiteBinCards;
